export default __webpack_public_path__ + "static/media/d23.3e6c6126.png";